export const CAMPAIGN_PROPERTIES = {
  ACTION_METADATA: 'hs_action_metadata',
  BUSINESS_UNIT_IDS: 'hs_all_assigned_business_unit_ids',
  COLOR: 'hs_color_hex',
  CREATED_AT: 'hs_created_at',
  LAST_UPDATED_AT: 'hs_lastmodifieddate',
  CREATED_BY_USER_ID: 'hs_created_by_user_id',
  GUID: 'hs_origin_asset_id',
  NAME: 'hs_name',
  NOTES: 'hs_notes',
  OBJECT_ID: 'hs_object_id',
  TEAM_IDS: 'hs_all_team_ids',
  START_DATE: 'hs_start_date',
  END_DATE: 'hs_end_date',
  OWNER: 'hs_owner',
  AUDIENCE: 'hs_audience',
  GOAL: 'hs_goal',
  UPDATED_BY_USER_ID: 'hs_updated_by_user_id',
  UTM: 'hs_utm',
  TEMPLATE_GUID: 'hs_template_guid',
  COMMENT: 'hs_comment',
  CURRENCY_CODE: 'hs_currency_code',
  SUPPORTS_ASSET_PLACEHOLDERS: 'hs_supports_asset_placeholders'
};